import clsx from 'clsx';
import { MakeIconMono } from '../../atoms/MakeIconMono';

interface NoImageWrapperProps {
  make?: string;
  className?: string;
  makeIconClassName?: string;
  variant?: 'blue' | 'gray';
  needNoImageText?: boolean;
}

export const NoImageWrapper: React.FC<NoImageWrapperProps> = ({
  make = null,
  className = 'm-auto mb-s',
  makeIconClassName,
  variant = 'blue',
  needNoImageText = true,
}) => {
  return (
    <div className="m-auto">
      <div
        className={clsx(
          className,
          variant === 'blue' && 'bg-blue-light text-blue-medium',
          variant === 'gray' && 'bg-neutral-200 text-neutral-600'
        )}
      >
        {make && (
          <MakeIconMono
            make={make}
            className={clsx('m-auto mb-s', makeIconClassName)}
          />
        )}
        {needNoImageText && (
          <div className="hidden whitespace-nowrap m:block">
            Image coming soon
          </div>
        )}
      </div>
    </div>
  );
};
